import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/auth/home.jsx";
import EmailVerification from "../pages/auth/emailVerification.jsx";
import ResetPassword from "../pages/auth/resetPassword.jsx";
import PageNotFound from "../pages/pageNotFound.js";

// Protected pages
import Chat from "../pages/patient/chat.jsx";
import UpcomingAppointments from "../pages/patient/upcomingAppointments.jsx";
import UpcomingAppointmentDetail from "../pages/patient/upcomingAppointmentDetail.jsx";
import PastAppointments from "../pages/patient/pastAppointments.jsx";
import PastAppointmentDetail from "../pages/patient/pastAppointmentDetail.jsx";
import ReviewPatientForm from "../pages/patient/reviewPatientForm.jsx";
// import FilledForms from "../pages/filledForms.jsx";
import Profile from "../pages/patient/profile.jsx";

import TelemedicineConsentForm from "../components/form.js";
import Appointments from "../pages/physician/UpcomingAppointments.jsx";
import PatientPreview from "../pages/physician/PatientPreview.jsx";

const authProtectedRoutes = [
  { path: "/chat", component: <Chat /> },
  { path: "/upcoming-appointment", component: <UpcomingAppointments /> },
  { path: "/upcoming-appointment-detail", component: <UpcomingAppointmentDetail /> },
  { path: "/review-patient-form", component: <ReviewPatientForm /> },
  { path: "/past-appointment", component: <PastAppointments /> },
  { path: "/past-appointment-detail", component: <PastAppointmentDetail /> },
  // { path: "/submitted-forms", component: <FilledForms /> },
  { path: "/profile", component: <Profile /> },
  { path: "/form", component: <TelemedicineConsentForm /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  //   {
  //     path: "/",
  //     exact: true,
  //     component: <Navigate to="/dashboard" />,
  //   },
  { path: "*", component: <PageNotFound /> },
  
];

const publicRoutes = [
  { path: "/", exact: true, component: <Login /> },
  { path: "/verify-email", exact: true, component: <EmailVerification /> },
  { path: "/reset-password", exact: true, component: <ResetPassword /> },
];

// Physician Portal
const physicianRoutes = [
  { path: "/physician/appointments", component: <Appointments /> },
  { path: "/physician/patient-preview", component: <PatientPreview /> },
];

export { authProtectedRoutes, publicRoutes, physicianRoutes };
